import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { compose } from 'recompose';
import IScroll from 'iscroll';
import platform from 'platform';

import withUrlGenerator from '../../lib/withUrlGenerator';
import withTranslations from '../../lib/withTranslations';

const IS_ANDROID = platform.os.family.toLowerCase().indexOf('android') !== -1;

const propTypes = {
    t: PropTypes.func.isRequired,
};

class InfoPage extends Component {
    constructor(props) {
        super(props);
        this.scroll = null;
        this.refContainer = null;
        this.refreshTimeout = null;
    }

    componentDidMount() {
        if (!IS_ANDROID) {
            this.scroll = new IScroll(this.refContainer, {
                mouseWheel: true,
                bounce: true,
            });

            this.refreshTimeout = setTimeout(() => {
                this.refreshTimeout = null;
                if (this.scroll !== null) {
                    this.scroll.refresh();
                }
            }, 100);
        }

        gaTrackPage('info');
    }

    componentDidUpdate() {
        if (this.scroll !== null) {
            this.scroll.refresh();
        }
    }

    componentWillUnmount() {
        if (this.refreshTimeout !== null) {
            clearTimeout(this.refreshTimeout);
        }

        if (this.scroll !== null) {
            this.scroll.destroy();
            this.scroll = null;
        }
    }

    render() {
        const { t } = this.props;
        const style = {
            overflow: IS_ANDROID ? 'auto' : null,
        };
        return (
            <div
                className="page page-info"
                style={style}
                ref={(ref) => { this.refContainer = ref; }}
            >
                <div className="inner">
                    <h1 className="title">
                        <ReactMarkdown source={t('title')} />
                    </h1>

                    <div className="page-content">
                        <div className="inner">
                            <ReactMarkdown source={t('info_description_1')} className="text bigger" />

                            <ReactMarkdown source={t('info_description_2')} className="text bigger" />

                            <h4 className="subtitle">{ t('how_to_hum') }</h4>

                            <ReactMarkdown source={t('hum_description')} className="text" />

                            <hr />

                            <h4 className="subtitle bigger">{ t('general_information') }</h4>

                            <ReactMarkdown source={t('info_from')} className="text" />

                            <ReactMarkdown source={t('info_funding')} className="text" />

                            <ReactMarkdown source={t('exhibition_info')} className="text" />

                            <ReactMarkdown source={t('exhibition_dates')} className="text" />

                            <ReactMarkdown source={t('exhibition_schedules')} className="text" />

                            <ReactMarkdown source={t('exhibition_notes')} className="text" />

                            <ReactMarkdown source={t('museum_contact')} className="text contact" />

                            <ReactMarkdown source={t('findus_social')} className="text no-margin" />
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/macmontreal" target="_blank" rel="noopener noreferrer">Facebook</a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/macmtl" target="_blank" rel="noopener noreferrer">Twitter</a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/macmontreal/" target="_blank" rel="noopener noreferrer">Instagram</a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/user/MACMvideos" target="_blank" rel="noopener noreferrer">YouTube</a>
                                </li>
                            </ul>

                            <p>
                                <a
                                    href="http://www.dailytouslesjours.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >www.dailytouslesjours.com</a>
                            </p>
                        </div>
                    </div>

                    <div className="page-content white">
                        <div className="inner">
                            <h4 className="subtitle bigger">{ t('credits') }</h4>

                            <div className="table">
                                <div className="cell">
                                    <ReactMarkdown source={t('credits_col_1')} className="credits" />
                                </div>
                                <div className="cell big">
                                    <ReactMarkdown source={t('credits_choir_title')} className="credits" />
                                    <div className="table">
                                        <div className="cell">
                                            <ReactMarkdown source={t('credits_col_2')} className="credits" />
                                        </div>
                                        <div className="cell">
                                            <ReactMarkdown source={t('credits_col_3')} className="credits" />
                                        </div>
                                        <div className="cell">
                                            <ReactMarkdown source={t('credits_col_4')} className="credits" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

InfoPage.propTypes = propTypes;

const enhancer = compose(
    withUrlGenerator(),
    withTranslations(),
);
export default enhancer(InfoPage);



// WEBPACK FOOTER //
// ./components/pages/Info.jsx